export default "__VITE_ASSET__DDcxBhIr__"